module.exports = __webpack_public_path__ + "static/toggle-39d451eea40aa2dadd996bbbe9373f37.mp3";